import { getEvents, fillInTable } from "../../frameworks/mz-wp-api";
import ListPagination from "../global/listPagination";

import * as ReactDOM from "react-dom/client";
import { wpFetch } from "../../main.top";

const getContainer = (sectionID) => document.getElementById(sectionID);
const getPaginationContainer = (sectionID) => document.querySelector(`#${sectionID} > .container > .pagination`);

const drawList = (sectionObject, selectedTerms = { category: undefined }, toPage = false) => {
    if (toPage) {
        paginationDraw(sectionObject, true);
    }

    /**
     * A filter is set? Then update the request body.
     * A filter is NOT set? Then remove the parameter 'cat' from the request body.
     */
    if (selectedTerms.filtered) {
        sectionObject.reqBody["page"] = 1;
        sectionObject.reqBody["pagesAmount"] = undefined;
        sectionObject.reqBody["sectorsCategories"] = selectedTerms.sectorsCategories;
        sectionObject.reqBody["companiesCategories"] = selectedTerms.companiesCategories;
        sectionObject.reqBody["yearsCategories"] = selectedTerms.yearsCategories;
        sectionObject.reqBody["quartersCategories"] = selectedTerms.quartersCategories;
    } else if (!selectedTerms.filtered && nextPage === false && resetPage === false) {
        sectionObject.reqBody["page"] = 1;
        sectionObject.reqBody["pagesAmount"] = undefined;
        delete sectionObject.reqBody["sectorsCategories"];
        delete sectionObject.reqBody["companiesCategories"];
        delete sectionObject.reqBody["yearsCategories"];
        delete sectionObject.reqBody["quartersCategories"];
    }

    if (sectionObject.container === undefined) sectionObject.container = getContainer(sectionObject.containerID);

    sectionObject.container.classList.add("loading");

    if (sectionObject.paginationContainer === undefined) sectionObject.paginationContainer = getPaginationContainer(sectionObject.containerID);

    if (sectionObject.paginationRoot === undefined) sectionObject.paginationRoot = ReactDOM.createRoot(sectionObject.paginationContainer);

    // If the query changed, then update the pagination
    if (toPage === false) {
        let payload = structuredClone(sectionObject.reqBody);
        payload["action"] = "getEventPagesAmountMultiple";
        payload["order"] = "DESC";

        wpFetch("POST", ajaxurl, payload).then((res) => {
            res.json()
                .then((response) => {
                    sectionObject.reqBody["pagesAmount"] = response.pages;

                    sectionObject.paginationContainer.classList.toggle("disabled", !(sectionObject.reqBody["pagesAmount"] > 1));
                    paginationDraw(sectionObject, true);
                })
                .catch((err) => console.error(err));
        });
    }

    getEvents(sectionObject.reqBody).then((res) => {
        sectionObject.fillIn(res);
        sectionObject.container.classList.remove("loading");
        paginationDraw(sectionObject, false);
    });
};

const toPage = function (sectionObject, pageTarget) {
    const currentPage = sectionObject.reqBody["page"];
    const pages = sectionObject.reqBody["pagesAmount"];

    sectionObject.reqBody["page"] = pageTarget >= 1 && pageTarget <= pages ? pageTarget : currentPage;
    sectionObject.init(undefined, true);
};

const prevPage = function (sectionObject) {
    const currentPage = sectionObject.reqBody["page"];

    sectionObject.reqBody["page"] = currentPage - 1 >= 1 ? currentPage - 1 : currentPage;
    sectionObject.init(undefined, true);
};

const nextPage = function (sectionObject) {
    const currentPage = sectionObject.reqBody["page"];
    const pages = sectionObject.reqBody["pagesAmount"];

    sectionObject.reqBody["page"] = currentPage + 1 <= pages ? currentPage + 1 : pages;
    sectionObject.init(undefined, true);
};

/**
 *
 * @param {sections} sectionObject
 * @param {Boolean} loading
 */
const paginationDraw = (sectionObject, loading) => {
    sectionObject.paginationRoot.render(<ListPagination sectionObject={sectionObject} currentPage={sectionObject.reqBody["page"]} pages={sectionObject.reqBody["pagesAmount"]} prevPage={prevPage} toPage={toPage} nextPage={nextPage} isLoading={loading} />);
};

const sections = {
    live: {
        container: undefined,
        containerID: "listLiveEvents",
        reqBody: {
            action: "getEventsMultiple",
            status: "all",
            isLive: "true",
            order: "DESC",
            posts_per_page: -1,
            page: 1,
        },
        paginationRoot: undefined,
        paginationContainer: undefined,
        fillIn: function (withThis) {
            fillInTable(this.container, withThis, false, true);
        },
        init: function (categoriesList, nextPage) {
            drawList(this, categoriesList, nextPage);
        },
    },
    scheduled: {
        container: undefined,
        containerID: "listFutureEvents",
        reqBody: {
            action: "getEventsMultiple",
            status: "future",
            isLive: "false",
            order: "ASC",
            posts_per_page: 10,
            page: 1,
        },
        paginationRoot: undefined,
        paginationContainer: undefined,
        fillIn: function (withThis) {
            fillInTable(this.container, withThis, true, false);
        },
        init: function (categoriesList, nextPage) {
            drawList(this, categoriesList, nextPage);
        },
    },
    past: {
        container: undefined,
        paginationContainer: undefined,
        containerID: "listPastEvents",
        reqBody: {
            action: "getEventsMultiple",
            status: "publish",
            isLive: "false",
            order: "DESC",
            posts_per_page: 10,
            page: 1,
        },
        paginationRoot: undefined,
        paginationContainer: undefined,
        fillIn: function (withThis) {
            fillInTable(this.container, withThis, false, true);
        },
        init: function (categoriesList, nextPage) {
            drawList(this, categoriesList, nextPage);
        },
    },
};

export function renderTableEvents(categoriesList) {
    setTimeout(() => {
        sections.live.init(categoriesList);
        sections.scheduled.init(categoriesList);
        sections.past.init(categoriesList);
    }, 4000);
}
